import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UnitMstApi } from '../api/unitmst.api';
import { switchMap, map } from 'rxjs/operators';

import { UnitMstData, UnitMst } from '../../../interfaces/masters/unitmst' ;
@Injectable()
export class UnitMstService extends UnitMstData {

    constructor(private api: UnitMstApi) {
      super();
    }
  
  
    list(url: string): Observable<UnitMst[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<UnitMst>{
        return this.api.getById(url);
    }
  
    create(url: string, data:UnitMst): Observable<UnitMst[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:UnitMst): Observable<UnitMst> {
      return this.api.update(url,data);
    }
  
    //for labunitmst excelport
    postData(url: string, data:any[]): Observable<any> {
      return this.api.addData(url,data);
    }
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  